/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Failed_TitleInputs */



/**
* | output |
* | --- |
* | "Recording failed" |
*
* @param {Meeting_Offline_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_failed_title = /** @type {((inputs?: Meeting_Offline_Failed_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Failed_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname mislukt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement échoué")
	return /** @type {LocalizedString} */ ("Recording failed")
});